import React from "react";

import { Button, Container, Grid, Text, useMantineTheme, Box, Group } from '@mantine/core';

import { notifications } from '@mantine/notifications';

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import ModalWrapperWithoutFooter from "../../components/general/ModalWrapperWithoutFooter";
import ModalWrapperWithFooterCloseButton from "../../components/general/ModalWrapperWithFooterCloseButton";

import PickerDate from "../../components/general/PickerDate";
import PickerMonth from "../../components/general/PickerMonth";
import PickerTime from "../../components/general/PickerTime";
import PickerYear from "../../components/general/PickerYear";

import { utils } from "../../utils/globalVariables";

const Components = () => {

    const theme = useMantineTheme();

    const notificationId = {
        success: 'components-success',
        warning: 'components-warning',
        error: 'components-error',
    }

    const [data, setData] = React.useState({
        modalResponseSuccess: false,
        modalResponseWarning: false,
        modalResponseDanger: false,

        modalTakeAction1: false,
        modalTakeAction1Loading: false,

        modalTakeAction2: false,
        modalTakeAction2Loading: false,

        modalWrapperWithOutFooter: false,
        modalWrapperWithFooterCloseButton: false,

        tanggal1: new Date(),
        tanggal2: new Date(),
        tanggal3: "00:00",
        tanggal4: new Date(),
    })

    const contentModalTakeActionLong = Array(100).fill(0).map((_, index) => <div key={index}>Lorem Ipsum Dolor Sit Amet</div>);

    return (
        <React.Fragment>
            <Container
                fluid
            >
                <Grid mt={0}>
                    <Grid.Col py='xs'>
                        <Box mt='sm' mb='xl'>
                            <Text
                                sx={{ fontWeight: '500', fontSize: theme.fontSizes.lg }}
                            >
                                Modal Response
                            </Text>

                            <Group mt='sm'>
                                <Button
                                    size="xs"
                                    color="teal"
                                    onClick={() => setData(d => ({ ...d, modalResponseSuccess: true }))}
                                >
                                    Success
                                </Button>

                                <Button
                                    size="xs"
                                    color="orange"
                                    onClick={() => setData(d => ({ ...d, modalResponseWarning: true }))}
                                >
                                    Warning
                                </Button>

                                <Button
                                    size="xs"
                                    color="red"
                                    onClick={() => setData(d => ({ ...d, modalResponseDanger: true }))}
                                >
                                    Danger
                                </Button>
                            </Group>
                        </Box>

                        <Box mt='2rem'>
                            <Text
                                sx={{ fontWeight: '500', fontSize: theme.fontSizes.lg }}
                            >
                                Modal Take Action
                            </Text>

                            <Group mt='sm'>
                                <Button
                                    size="xs"
                                    // color="teal"
                                    onClick={() => setData(d => ({ ...d, modalTakeAction1: true }))}
                                >
                                    Short Content
                                </Button>

                                <Button
                                    size="xs"
                                    // color="teal"
                                    onClick={() => setData(d => ({ ...d, modalTakeAction2: true }))}
                                >
                                    Long Content
                                </Button>
                            </Group>
                        </Box>

                        <Box mt='2rem'>
                            <Text
                                sx={{ fontWeight: '500', fontSize: theme.fontSizes.lg }}
                            >
                                Modal Wrapper
                            </Text>

                            <Group mt='sm'>
                                <Button
                                    size="xs"
                                    // color="teal"
                                    onClick={() => setData(d => ({ ...d, modalWrapperWithOutFooter: true }))}
                                >
                                    Without Footer
                                </Button>

                                <Button
                                    size="xs"
                                    // color="teal"
                                    onClick={() => setData(d => ({ ...d, modalWrapperWithFooterCloseButton: true }))}
                                >
                                    With Footer Close Button
                                </Button>
                            </Group>
                        </Box>

                        <Box mt='2rem'>
                            <Text sx={{ fontWeight: '500', fontSize: theme.fontSizes.lg }}>Notification</Text>

                            <Group mt='sm'>
                                <Button
                                    size="xs"
                                    color="teal"
                                    onClick={() => {
                                        notifications.show({
                                            id: notificationId.success,
                                            title: utils.notification.success.caption,
                                            message: 'Lorem Ipsum Dolor Sit Amet',
                                            color: utils.notification.success.color,
                                            icon: utils.notification.success.icon,
                                            withBorder: true,
                                            autoClose: true,
                                        })
                                    }}
                                >
                                    Success
                                </Button>

                                <Button
                                    size="xs"
                                    color="orange"
                                    onClick={() => {
                                        notifications.show({
                                            id: notificationId.warning,
                                            title: utils.notification.warning.caption,
                                            message: 'Lorem Ipsum Dolor Sit Amet',
                                            color: utils.notification.warning.color,
                                            icon: utils.notification.warning.icon,
                                            withBorder: true,
                                            autoClose: true,
                                        })
                                    }}
                                >
                                    Warning
                                </Button>

                                <Button
                                    size="xs"
                                    color="red"
                                    onClick={() => {
                                        notifications.show({
                                            id: notificationId.error,
                                            title: utils.notification.error.caption,
                                            message: 'Lorem Ipsum Dolor Sit Amet',
                                            color: utils.notification.error.color,
                                            icon: utils.notification.error.icon,
                                            withBorder: true,
                                            autoClose: true,
                                        })
                                    }}
                                >
                                    Error
                                </Button>
                            </Group>
                        </Box>

                        <Box mt='2rem'>
                            <Text sx={{ fontWeight: '500', fontSize: theme.fontSizes.lg }}>Date Picker</Text>

                            <Group mt='sm'>
                                <PickerDate
                                    stateDate={data.tanggal1}
                                    fnSetDate={(val) => setData(d => ({ ...d, tanggal1: val }))}

                                    stateLabel='Tanggal Penjualan'
                                    statePlaceHolder='Tanggal Penjualan'
                                />

                                <PickerMonth
                                    stateDate={data.tanggal2}
                                    fnSetDate={(val) => setData(d => ({ ...d, tanggal2: val }))}

                                    stateLabel='Bulan Penjualan'
                                    statePlaceHolder='Bulan Penjualan'
                                />

                                <PickerTime
                                    stateDate={data.tanggal3}
                                    fnSetDate={(val) => {
                                        setData(d => ({ ...d, tanggal3: val.target.value }))
                                    }}

                                    stateLabel='Jam Jemput'
                                />

                                <PickerYear
                                    stateDate={data.tanggal4}
                                    fnSetDate={(val) => setData(d => ({ ...d, tanggal4: val }))}

                                    stateLabel='Tahun Penjualan'
                                    statePlaceHolder='Tahun Penjualan'
                                />
                            </Group>
                        </Box>
                    </Grid.Col>
                </Grid>
            </Container>

            <ModalResponse
                stateShow={data.modalResponseSuccess}
                fnHide={() => setData(d => ({ ...d, modalResponseSuccess: false }))}

                stateHideOnClickOutSide={true}
                stateType={utils.modalResponse.success}
                stateContent='Lorem Ipsum Dolor Sit Amet'
            />

            <ModalResponse
                stateShow={data.modalResponseWarning}
                fnHide={() => setData(d => ({ ...d, modalResponseWarning: false }))}

                stateHideOnClickOutSide={true}
                stateType={utils.modalResponse.warning}
                stateContent='Lorem Ipsum Dolor Sit Amet'
            />

            <ModalResponse
                stateShow={data.modalResponseDanger}
                fnHide={() => setData(d => ({ ...d, modalResponseDanger: false }))}

                stateHideOnClickOutSide={true}
                stateType={utils.modalResponse.danger}
                stateContent='Lorem Ipsum Dolor Sit Amet'
            />

            <ModalTakeAction
                stateShow={data.modalTakeAction1}
                fnHide={() => setData(d => ({ ...d, modalTakeAction1: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Title').toUpperCase()}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionLoading={data.modalTakeAction1Loading}
                fnButtonAction={() => {
                    setData(d => ({ ...d, modalTakeAction1Loading: true }))
                    setTimeout(() => {
                        setData(d => ({ ...d, modalTakeAction1Loading: false }))
                    }, 1000);
                }}
            >
                Lorem Ipsum Dolor Sit Amet
            </ModalTakeAction>

            <ModalTakeAction
                stateShow={data.modalTakeAction2}
                fnHide={() => setData(d => ({ ...d, modalTakeAction2: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Title').toUpperCase()}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionLoading={data.modalTakeAction2Loading}
                fnButtonAction={() => {
                    setData(d => ({ ...d, modalTakeAction2Loading: true }))
                    setTimeout(() => {
                        setData(d => ({ ...d, modalTakeAction2Loading: false }))
                    }, 1000);
                }}
            >
                {contentModalTakeActionLong}
            </ModalTakeAction>

            <ModalWrapperWithoutFooter
                stateShow={data.modalWrapperWithOutFooter}
                fnHide={() => setData(d => ({ ...d, modalWrapperWithOutFooter: false }))}
                stateHideOnClickOutSide={true}
                stateTitle='Choose one data'
                stateSize='md'
            >
                {contentModalTakeActionLong}
            </ModalWrapperWithoutFooter>

            <ModalWrapperWithFooterCloseButton
                stateShow={data.modalWrapperWithFooterCloseButton}
                fnHide={() => setData(d => ({ ...d, modalWrapperWithFooterCloseButton: false }))}
                stateHideOnClickOutSide={true}
                stateTitle={String('Title').toUpperCase()}
                stateSize='xl'
                stateOverlayZIndex={201}
                stateWithCloseButton={true}
                stateScrollArea={true}

                stateButtonCloseCaption="Close"
                stateButtonCloseSize="sm"
                stateButtonClosePx="lg"
            >
                {contentModalTakeActionLong}
            </ModalWrapperWithFooterCloseButton>

        </React.Fragment>
    )
}

export default Components;